// 环境报价接口
import api from './index'
import {
	axios,
	pureAxios,
	pyAxios
} from '@/utils/request'
//获取行业大类子类
export function getIndusryInfoList(parameter) {
	return axios({
		url: '/quote/quote/industryInfo/getIndusryInfoList',
		method: 'get',
		params: parameter
	})
}
//查询报价主分类
export function getCategoryList(parameter) {
	return axios({
		url: '/quote/quote/category/list',
		method: 'get',
		params: parameter
	})
}
//新增行业信息
export function industryInfo(parameter) {
	return axios({
		url: '/quote/quote/industryInfo',
		method: 'post',
		data: parameter
	})
}
//编辑行业信息
export function editIndustryInfo(parameter) {
	return axios({
		url: '/quote/quote/industryInfo',
		method: 'put',
		data: parameter
	})
}
// 删除行业信息
export function deleteIndustryInfo(key) {
	return axios({
		url: '/quote/quote/industryInfo/delete/' + `${key}`,
		method: 'delete'
	})
}
//获取检测类别列表
export function getTestType(parameter) {
	return axios({
		url: '/quote/quote/pollutant/getTestType',
		method: 'get',
		params: parameter
	})
}
// 获取污染物（通过行业大类id、行业子类id、检测类型id）
export function getRelationPollutantByTypes(parameter) {
	return axios({
		url: '/quote/quote/pollutant/getRelationPollutantByTypes',
		method: 'get',
		params: parameter
	})
}
 //获取污染物类别列表
 export function getPollotantList(parameter) {
	return axios({
		url: '/quote/quote/type/list',
		method: 'get',
		params: parameter
	})
}
 //职卫获取污染物类别列表
 export function getPollutantTypeList(parameter) {
	return axios({
		url: '/quote/quote/type/getPollutantTypeList',
		method: 'get',
		params: parameter
	})
}
//查询污染物详细列表
export function getChargeList(parameter) {
	return axios({
		url: '/quote/quote/charge/list',
		method: 'get',
		params: parameter
	})
}
// 污染物新增关联
export function addReation(parameter) {
	return axios({
		url: '/quote/quote/pollutant/addReation',
		method: 'put',
		data: parameter
	})
}

//查询污染物基础信息列表（过滤已关联的）
export function getQuoteBaseFactorFilterList(parameter) {
	return axios({
		url: '/quote/quote/baseFactor/getQuoteBaseFactorFilterList',
		method: 'get',
		params: parameter
		// method: 'post',
		// data: parameter
	})
}
// 删除关联污染物
export function deletePollutant(parameter) {
	return axios({
		url: '/quote/quote/pollutant/deletePollutant',
		method: 'post',
		data: parameter
	})
}
// 删除行业类别污染物类别关联
export function pollutant(key) {
	return axios({
		url: '/quote/quote/pollutant/' + `${key}`,
		method: 'delete'
	})
}
//新增点位信息（自定义）
export function addPointInfo(parameter) {
	return axios({
		url: '/quote/quote/pointInfo/addPointInfo',
		method: 'post',
		data: parameter
	})
}
// 查询(环境)子类检测项目列表
export function testItemList(parameter) {
	return axios({
		url: '/quote/quote/testItem/list',
		method: 'get',
		params: parameter
	})
}
//获取污染物信息 根据主类id、子类id、检测类型id
export function getPollutantInfo(parameter) {
	return axios({
		url: '/quote/quote/pollutant/getPollutantInfo',
		method: 'post',
		data: parameter
	})
}
// 修改点位信息
export function editPointInfo(parameter) {
	return axios({
		url: '/quote/quote/pointInfo',
		method: 'put',
		data: parameter
	})
}
// 批量新增(环境)子类检测项目
export function itemAddBatch(parameter) {
	return axios({
		url: '/quote/quote/testItem/addBatch',
		method: 'post',
		data: parameter
	})
}
// 批量修改(环境)子类检测项目
export function editBatch(parameter) {
	return axios({
		url: '/quote/quote/testItem/editBatch',
		method: 'put',
		data: parameter
	})
}
//查询点位信息列表
export function pointInfoList(parameter) {
	return axios({
		url: '/quote/quote/pointInfo/list',
		method: 'get',
		params: parameter
	})
}
// 根据【表单id、子类id、点位id、检测类型id】
export function getTestItemByPointId(parameter) {
	return axios({
		url: '/quote/quote/testItem/getTestItemByPointId',
		method: 'get',
		params: parameter
	})
}
// 查询行业信息列表（职卫、公卫）
export function getIndusryInfoUserList(parameter) {
	return axios({
		url: '/quote/quote/industryInfo/getIndusryInfoUserList',
		method: 'get',
		params: parameter
	})
}
// 获取检测类别列表（公卫--web端参数设置）
export function getPollutantType(parameter) {
	return axios({
		url: '/quote/quote/pollutant/getPollutantType',
		method: 'get',
		params: parameter
	})
}
// 污染物新增关联
export function addPollutantType(parameter) {
	return axios({
		url: '/quote/quote/type/addPollutantType',
		method: 'put',
		data: parameter
	})
}
// 查询收费标准列表
export function standardList(parameter) {
	return axios({
		url: '/quote/quote/standard/list',
		method: 'get',
		params: parameter
	})
}
//获取检测类别关联的污染物（公卫--编辑页面）
export function getRelationBaseFactor(parameter) {
	return axios({
		url: '/quote/quote/testPollutant/getRelationBaseFactor',
		method: 'get',
		params: parameter
	})
}
// 查询污染物基础信息列表（公卫)
export function getQuoteBaseFactorRelationList(parameter) {
	return axios({
		url: '/quote/quote/baseFactor/getQuoteBaseFactorRelationList',
		method: 'get',
		params: parameter
	})
}
// 获取污染物（公卫--过滤已报价）
export function getQuoteRelationFactorList(parameter) {
	return axios({
		url: '/quote/quote/baseFactor/getQuoteRelationFactorList',
		method: 'get',
		params: parameter
	})
}
// 检测类别删除、批量删除（公卫）
export function deleteCategoryPollutant(key) {
	return axios({
		url: '/quote/quote/pollutant/deleteCategoryPollutant/' + `${key}`,
		method: 'delete'
	})
}
// 编辑检测类别（添加污染物关联关联）
export function addRelationCaregoryAndPollutant(parameter) {
	return axios({
		url: '/quote/quote/type/addRelationCaregoryAndPollutant',
		method: 'post',
		data: parameter
	})
}
// 删除行业类别污染物类别关联（自定义--公卫）
export function pollutantDelete(key) {
	return axios({
		url: '/quote/quote/pollutant/delete/' + `${key}`,
		method: 'delete'
	})
}
// 职卫、 环境、公卫(污染物)删除、批量删除
export function baseFactorDelete(key) {
	return axios({
		url: '/quote/quote/baseFactor/delete/' + `${key}`,
		method: 'delete'
	})
}
// 环境-检测类别列表-删除、批量删除
export function deleteTestType(parameter) {
	return axios({
		url: '/quote/quote/pollutant/deleteTestType',
		method: 'post',
		data: parameter
	})
}
// 环境-检测类别列表-删除
export function deleteTestPollutant(parameter) {
	return axios({
		url: '/quote/quote/testPollutant/delete ',
		method: 'post',
		data: parameter
	})
}
//删除报价检测项目
export function deleteItems(key) {
	return axios({
		url: '/quote/quote/testItem/' + `${key}`,
		method: 'delete'
	})
}
//删除职卫岗位列表
export function deletePostInfo(key) {
	return axios({
		url: '/quote/quote/postInfo/' + `${key}`,
		method: 'delete'
	})
}
//获得生成报价（环境、公卫）第三步列表编辑
export function getTestItemEdit(parameter) {
	return axios({
		url: '/quote/quote/testItem/getTestItemEdit',
		method: 'get',
		params: parameter
	})
}
// 删除点位及报价信息
export function deleteQuoteInfo(parameter) {
	return axios({
		url: '/quote/quote/testItem/deleteQuoteInfo',
		method: 'post',
		params: parameter
	})
}
// 编辑检测类别（公卫）
export function editPollutantType(parameter) {
	return axios({
		url: '/quote/quote/pollutant/editPollutantType',
		method: 'post',
		data: parameter
	})
}
// 报价导出
export function exportPrice(parameter) {
	return axios({
		url: '/quote/quote/info/export',
		method: 'post',
		data: parameter
	})
}
//pdf预览
export function prePdf(parameter) {
	return axios({
		url: '/file/file/pre_pdf',
		method: 'get',
		params: parameter
	})
}
// // 合同导出
// export function exportContract(parameter) {
// 	return axios({
// 		url: '/quote/quote/info/exportContract',
// 		method: 'post',
// 		data: parameter
// 	})
// }



// 获取污染物（公卫--过滤已报价）
// export function getQuoteRelationFactorList(parameter) {
// 	return axios({
// 		url: '/quote/quote/baseFactor/getQuoteRelationFactorList',
// 		method: 'get',
// 		params: parameter
// 	})
// }
// // 公卫类别列表-删除、批量删除
// export function deleteCategoryPollutant(key) {
// 	return axios({
// 		url: '/quote/pollutant/deleteCategoryPollutant/' + `${key}`,
// 		method: 'delete'
// 	})
// }
//   环境、公卫-行业列表-删除、批量删除
// export function industryInfoDelete(key) {
// 	return axios({
// 		url: '/quote/industryInfo/delete/' + `${key}`,
// 		method: 'delete'
// 	})
// }


// // 获取污染物信息 根据主类id、子类id、检测类型id
// export function getPollutantInfo(parameter) {
// 	return axios({
// 		url: '/quote/quote/pollutant/getPollutantInfo',
// 		method: 'post',
// 		data: parameter
// 	})
// }



// // 查询污染物类别列表(参数设置)
// export function getTypeList(parameter) {
// 	return axios({
// 		url: '/quote/quote/type/list',
// 		method: 'get',
// 		params: parameter
// 	})
// }

// export function deleteFactor(key) {
// 	return axios({
// 		url: '/quote/quote/factor/' + `${key}`,
// 		method: 'delete'
// 	})
// }